import { ProcessStageOverview } from "../validationProcessApi";


export type StageCode = "URS" | "RA" | "DQ" | "VALIDATION" | "AC" | string;

const STAGE_META: Record<
    StageCode,
    {
        label: string;
        description: string;
    }
> = {
    URS: {
        label: "URS – wymagania użytkownika",
        description:
            "Na tym etapie definiowane są wymagania użytkownika wobec systemu/urządzenia (URS).",
    },
    RA: {
        label: "RA – Analiza ryzyka",
        description:
            "Analiza ryzyka systemu/urządzenia.",
    },
    AC: {
        label: "AC – Analiza krytyczności",
        description:
            "Analiza krytyczności.",
    },
    ACS: {
        label: "ACS – Analiza krytyczności systemu",
        description:
            "Analiza krytyczności systemu/urządzenia.",
    },
    DQ: {
        label: "DQ – Design Qualification",
        description:
            "Weryfikacja czy projektowane rozwiązanie spełnia wymagania URS i wymagania regulacyjne.",
    },
    VALIDATION: {
        label: "Qualification (IQ/OQ/PQ)",
        description:
            "Qualification (IQ/OQ/PQ) obejmuje potwierdzenie prawidłowej instalacji, działania oraz wydajności systemu zgodnie z wymaganiami.",
    },

};

export function stageColorKey(code: string) {
    switch (code?.toUpperCase()) {
        case "URS":
            return "primary" as const;
        case "RA/CA":
            return "warning" as const;
        case "DQ":
            return "info" as const;
        case "VAL":
            return "success" as const;
        default:
            return "success" as const;
    }
}


export function getStageMeta(stage: ProcessStageOverview) {
    const code = (stage.stage || "").toUpperCase() as StageCode;
    const meta = STAGE_META[code];

    if (meta) return meta;

    return {
        label: stage.stage ?? "Etap",
        description: "Etap procesu walidacyjnego.",
    };
}
